<template>
  <div>
    <c-table
      ref="grid"
      title=""
      tableId="grid"
      topBorderClass="topcolor-orange"
      :columns="grid.columns"
      :data="grid.data"
      :isFullScreen="false"
      :columnSetting="false"
      :filtering="false"
      :usePaging="false"
      :hideBottom="true"
      :isExcelDown="false"
      @table-data-change="tableDataChange"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn
            v-if="editable"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="saveData"
            mappingType="PUT"
            label="저장"
            icon="save"
            @beforeAction="saveInfo"
            @btnCallback="saveCallback" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'chem-ghs-1',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        plantCd: '',
        plantName: '',
        materialCd: '',
        materialName: '',
        productCategoryCd: '',
        isSaved: '',
        updateFlag: '',
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            fix: true,
            name: 'chemNmKr',
            field: 'chemNmKr',
            label: '물질명(KR)',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            fix: true,
            name: 'chemNmEn',
            field: 'chemNmEn',
            label: '물질명(EN)',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            fix: true,
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
        ],
        data: [],
      },
      nationItems: [],
      saveData: [],
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.ghs.nation.list;
      this.saveUrl = transactionConfig.mdm.ghs.nation.save;
      // code setting
      // list setting
      this.getHeader();
      this.getList();
    },
    getHeader() {
      this.$comm.getComboItems('REGUL_ITEM_NATION_CD').then(_result => {
        this.$_.extend(this.nationItems, this.$_.map(_result, nation => {
          return nation.code.toLowerCase()
        }));
        this.$_.forEach(_result, _item => {
          this.grid.columns.push({
            name: _item.code.toLowerCase(),
            field: _item.code.toLowerCase(),
            label: _item.codeName,
            align: 'left',
            style: 'width:300px',
            setHeader: true,
            lang: _item.code.toLowerCase(),
            type: 'textarea',
            sortable: false,
          });
        })
      });
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        mdmChemMaterialId: this.param.mdmChemMaterialId
      };
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    tableDataChange(props, col) {
      /**
       * BACK 단에서 추가/수정 여부 판단
       * 따라서 변경이 이루어진 데이터 수집을 위한 처리
       */
      props.row[`${col.name}EditFlag`] = 'S'
    },
    saveInfo() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.saveData = [];
            this.$_.forEach(this.grid.data, item => {
              this.$_.forEach(this.nationItems, nation => {
                if (item[`${nation}EditFlag`] === 'S') {
                  this.saveData.push({
                    casNo: item.casNo,
                    regulItemNationCd: nation,
                    chemNmKr: item.chemNmKr,
                    chemNmEn: item.chemNmEn,
                    nationUnitGhsResult: item[nation],
                    chgUserId: this.$store.getters.user.userId,
                  })
                }
              })
            })
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
  }
};
</script>

<style lang="sass">
  .ghsinfodetail
    padding-bottom:10px !important
    margin-top:-20px
</style>